import { render, staticRenderFns } from "./downloader.vue?vue&type=template&id=4c4b2b7e"
import script from "./downloader.vue?vue&type=script&lang=js"
export * from "./downloader.vue?vue&type=script&lang=js"
import style0 from "./downloader.vue?vue&type=style&index=0&id=4c4b2b7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports